export type ShareTarget = 'whatsapp' | 'telegram' | 'email' | 'sms' | 'copy' | 'qr';

export type SharePayload = {
  title: string;
  text: string;
  url?: string;
};

export async function shareNative(payload: SharePayload): Promise<'shared' | 'unsupported' | 'cancelled'> {
  if (typeof navigator === 'undefined' || !('share' in navigator)) return 'unsupported';
  try {
    await (navigator as Navigator & { share: (p: ShareData) => Promise<void> }).share({
      title: payload.title,
      text: payload.text,
      ...(payload.url ? { url: payload.url } : {}),
    });
    return 'shared';
  } catch (e) {
    if ((e as { name?: string }).name === 'AbortError') return 'cancelled';
    return 'unsupported';
  }
}

export async function copyToClipboard(text: string): Promise<boolean> {
  if (typeof navigator === 'undefined' || !navigator.clipboard) return false;
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    return false;
  }
}

export function targetUrl(target: ShareTarget, payload: SharePayload): string | null {
  const text = payload.url ? `${payload.text} ${payload.url}` : payload.text;
  const e = encodeURIComponent(text);
  switch (target) {
    case 'whatsapp':
      return `https://wa.me/?text=${e}`;
    case 'telegram':
      return `https://t.me/share/url?url=${encodeURIComponent(payload.url ?? '')}&text=${encodeURIComponent(payload.text)}`;
    case 'email':
      return `mailto:?subject=${encodeURIComponent(payload.title)}&body=${e}`;
    case 'sms':
      return `sms:?&body=${e}`;
    default:
      return null;
  }
}

export function formatVerseShare(args: {
  bookName: string;
  chapter: number;
  verseNumber: number;
  verseText: string;
  appName: string;
  url: string;
}): SharePayload {
  const ref = `${args.bookName} ${args.chapter}:${args.verseNumber}`;
  return {
    title: `${ref} — ${args.appName}`,
    text: `"${args.verseText}" — ${ref}`,
    url: args.url,
  };
}
